import React, { useState } from 'react'
import { IoClose } from 'react-icons/io5'

interface ImageLightboxProps {
  isOpen: boolean
  imageUrl: string
  onClose: () => void
}

const ImageLightbox: React.FC<ImageLightboxProps> = ({ isOpen, imageUrl, onClose }) => {
  const [zoomLevel, setZoomLevel] = useState(1)
  const [transformOrigin, setTransformOrigin] = useState('center center')

  const handleImageClick = (e: React.MouseEvent<HTMLImageElement>) => {
    e.stopPropagation()
    const rect = e.currentTarget.getBoundingClientRect()
    const x = ((e.clientX - rect.left) / rect.width) * 100
    const y = ((e.clientY - rect.top) / rect.height) * 100

    if (zoomLevel === 1) {
      setTransformOrigin(`${x}% ${y}%`)
      setZoomLevel(2)
    } else {
      setZoomLevel(1)
      setTransformOrigin('center center')
    }
  }

  const handleClose = () => {
    setZoomLevel(1)
    setTransformOrigin('center center')
    onClose()
  }

  if (!isOpen) return null

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.9)',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
      }}
      onClick={handleClose}
    >
      <button
        style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          background: '#FA5A84',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          cursor: 'pointer',
          fontSize: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10001
        }}
        onClick={handleClose}
      >
        <IoClose size={24} />
      </button>
      <div
        style={{
          position: 'relative',
          maxWidth: '90%',
          maxHeight: '80%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={imageUrl}
          alt="Visualização ampliada"
          onClick={handleImageClick}
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            transform: `scale(${zoomLevel})`,
            transformOrigin: transformOrigin,
            transition: 'transform 0.3s ease',
            objectFit: 'contain',
            cursor: zoomLevel === 1 ? 'zoom-in' : 'zoom-out'
          }}
        />
      </div>
      <div style={{ marginTop: '20px', color: 'white', textAlign: 'center' }}>
        <p style={{ fontSize: '14px', margin: 0 }}>
          {zoomLevel === 1 ? 'Clique na imagem para ampliar' : 'Clique novamente para reduzir'}
        </p>
      </div>
    </div>
  )
}

export default ImageLightbox
